import classNames from 'classnames/bind'

import {useTraceContext} from '../../trace/TraceProvider'

import styles from './Toolbar.module.scss'

import type {FC} from 'react'

const cx = classNames.bind(styles)

interface ToolbarProps {
    count: number
    searchInput: string
    onSearchInputChange: (value: string) => void
}

const Toolbar: FC<ToolbarProps> = ({count, searchInput, onSearchInputChange}) => {
    const {clearTraces} = useTraceContext()

    return (
        <div className={cx('toolbar')}>
            <span className={cx('count')}>{count}개</span>
            <input
                type="text"
                className={cx('searchInput')}
                placeholder="필터링을 원하는 scope 혹은 메시지 입력"
                value={searchInput}
                onChange={(e) => onSearchInputChange(e.currentTarget.value)}
            />
            <button type="button" className={cx('clearButton')} onClick={() => clearTraces()}>
                Clear
            </button>
        </div>
    )
}

export default Toolbar
